import { render, staticRenderFns } from "./date-suggestions.vue?vue&type=template&id=fcb62cc0"
import script from "./date-suggestions.vue?vue&type=script&lang=js"
export * from "./date-suggestions.vue?vue&type=script&lang=js"
import style0 from "./date-suggestions.vue?vue&type=style&index=0&id=fcb62cc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports